"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchSignedUrlInfoWithSocket = void 0;
exports.isBlobImage = isBlobImage;
const react_1 = require("react");
const domain_1 = require("@home-health-notify/domain");
const OrganizationContext_1 = require("../context/OrganizationContext"); // Do not shorten this import as it creates a cyclic dependency
function isBlobImage(url) {
    return url === null || url === void 0 ? void 0 : url.startsWith("blob");
}
const useFetchSignedUrlInfoWithSocket = (url) => {
    const { selectedOrgUser } = (0, react_1.useContext)(OrganizationContext_1.OrganizationContext);
    const [signedUrlInfo, setSignedUrlInfo] = (0, react_1.useState)(undefined);
    const fetchSignedUrlInfo = (url) => {
        if (!selectedOrgUser)
            throw new domain_1.HhnException("No organization selected");
        selectedOrgUser.assetManager.getSignedUrlInfoWithSocket(url, (signedUrlInfo) => {
            setSignedUrlInfo(signedUrlInfo);
        });
    };
    (0, react_1.useEffect)(() => {
        setSignedUrlInfo(undefined);
        if (url && !isBlobImage(url)) {
            fetchSignedUrlInfo(url);
        }
    }, [url]);
    return isBlobImage(url) ? { expiry: 0, signedUrl: url } : signedUrlInfo;
};
exports.useFetchSignedUrlInfoWithSocket = useFetchSignedUrlInfoWithSocket;
